import type { ComponentProps } from 'react';
import { OwcIcon } from '@one/react';

export type PocIconProps = ComponentProps<typeof OwcIcon>;

export const PocIcon: React.FC<PocIconProps> = (props) => <OwcIcon {...props} />;
